import axios from "@/libs/axios";

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        create(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/users", data)
                    .then((response) => resolve(response.data))
                    .catch((error) => reject(error));
            });
        },
        read(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get("/users", { params: queryParams })
                    .then((response) => resolve(response.data))
                    .catch((error) => reject(error));
            });
        },
        readOne(ctx, { id, queryParams }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/users/${id}`, { params: queryParams })
                    .then((response) => resolve(response.data))
                    .catch((error) => reject(error));
            });
        },
        update(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .patch(`/users/${data.id}`, data)
                    .then((response) => resolve(response.data))
                    .catch((error) => reject(error));
            });
        },
        delete(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/users/${id}`)
                    .then((response) => resolve(response.data))
                    .catch((error) => reject(error));
            });
        },
    },
};
